import { render, staticRenderFns } from "./ProcessExternalPeople.vue?vue&type=template&id=2899af9e&scoped=true"
import script from "./ProcessExternalPeople.vue?vue&type=script&lang=js"
export * from "./ProcessExternalPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899af9e",
  null
  
)

export default component.exports